export default "__VITE_ASSET__c492d76e__"